import React from "react";
import { Container, Alert } from "react-bootstrap";
import { useNavigate } from "react-router";

const SignInException = () => {
    const nav = useNavigate();
    const onClick = () => {
        nav("/account/signin", { replace: true });
    };

    return (
        <Container>
            <Alert variant="danger" className="mt-3">
                Sign in failed.{" "}
                <Alert.Link onClick={onClick}>Try again.</Alert.Link>
            </Alert>
        </Container>
    );
};

export default SignInException;
